var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPlayTask(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.944 10.18C15.171 13.726 9.915 19 5.131 19a7.2 7.2 0 01-2.088-.42 2.771 2.771 0 01-.628-.288 2.9 2.9 0 01-1.045-1.046A2.736 2.736 0 011 15.844v-.264c0-.102.031-.21.057-.33.026-.12.06-.238.1-.354.868-3 3.024-3.102 3.854-6.864a5.267 5.267 0 011.876-2.97 5.715 5.715 0 013.399-1.23c.443-.017.887.02 1.32.108l.151.036c.19.01.377.038.56.084a5.516 5.516 0 013.025 2.406 5.106 5.106 0 01.602 3.714z",
    fill: "#FAB14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.008 9.478C12.241 13 7.155 18.124 2.44 18.292a2.904 2.904 0 01-1.06-1.042A2.737 2.737 0 011 15.844v-.264c0-.102.031-.21.057-.33.026-.12.06-.238.1-.354.868-3 3.024-3.102 3.854-6.864a5.267 5.267 0 011.876-2.97 5.715 5.715 0 013.4-1.23 5.414 5.414 0 012.316 2.403 5.09 5.09 0 01.405 3.243z",
    fill: "#FFD966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.795 3.922c.415-2.16 3.018-4.422 7.966-1.608 0 0-2.44 2.49-5.59 2.298a8.324 8.324 0 01-2.325-.294c-.095-.048-.063-.318-.05-.396z",
    fill: "#70CC70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.581 3.67c-3.08 1.83 5.765 4.896 6.048 7.59A8.64 8.64 0 0019 7c0-2.238-3.766-5.496-7.419-3.33z",
    fill: "#7EE67E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.659 8.005c.583-.983.557-2.05-.06-2.384-.615-.333-1.588.194-2.172 1.177-.584.983-.557 2.05.059 2.383.616.334 1.589-.193 2.173-1.176z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgPlayTask;